import type { PayloadAction } from '@reduxjs/toolkit';
import {
    GiftReceivedSelectors,
    handleFinishReceivedGiftsFallback,
    loadReceivedGiftsActionFallback,
} from 'reactApp/modules/giftReceived/receivedGiftBillingData.adapter';
import { loggerSaga } from 'reactApp/modules/logger/logger.saga';
import { initProducts } from 'reactApp/modules/products/products.module';
import {
    initPromoTariffs as initPromoTariffsAction,
    promoTariffsFailure,
    promoTariffsUpdateFailure,
    updatePromoTariffs,
} from 'reactApp/modules/promoTariffs/promoTariffs.module';
import type { TInitPromoTariffs } from 'reactApp/modules/promoTariffs/promoTariffs.types';
import {
    loadPromoTariffsActionFallback,
    PromoTariffsSelectors,
    updatePromoTariffsActionFallback,
} from 'reactApp/modules/promoTariffs/promoTariffsBillingData.adapter';
import { callSagaFromAction } from 'reactApp/utils/callSagaFromAction';
import { call, put, select, takeLatest } from 'redux-saga/effects';

// После 100% раскатки billingDataForPromoEnabled эта сага остается, но в ней заменяется фолбек на билингдату
export function* initPromoTariffs(data: TInitPromoTariffs) {
    const { onSuccess, onError, noCancel } = data || {};
    const promoList = yield select(PromoTariffsSelectors.getRawList);
    const giftsList = yield select(GiftReceivedSelectors.getRawGiftsList);

    try {
        if (promoList.length || giftsList.length) {
            onSuccess?.();
            return;
        }

        /** TODO: напрашивается, конечно распараллелить,
         *  но с учетом, что целимся в получение билингдаты с SSR в ближайшее время,
         * не вижу смысла сейчас распараллеливать, чтобы не усложнять переход на SSR */
        const data = yield call(loadPromoTariffsActionFallback);
        yield put(loadReceivedGiftsActionFallback());
        yield handleFinishReceivedGiftsFallback();
        const gifts = yield select(GiftReceivedSelectors.getRawGiftsList);

        if (gifts?.length || data?.length) {
            yield put(initProducts());
        }

        onSuccess?.();
    } catch (error) {
        onError?.();
        yield loggerSaga({ error, action: promoTariffsFailure(error as string), noCancel });
    }
}

// После 100% раскатки billingDataForPromoEnabled эта сага остается, но в ней заменяется фолбек на билингдату
const handleInitPromoTariffs = (action: PayloadAction<TInitPromoTariffs>) =>
    callSagaFromAction<TInitPromoTariffs>(initPromoTariffs, action);

function* handleUpdatePromoTariffs(action) {
    const { onSuccess, onError, promoId } = action.payload || {};
    try {
        if (promoId) {
            // @ts-ignore
            const product = yield select(PromoTariffsSelectors.getDiscountByProductId, promoId);
            if (product) {
                onSuccess?.();
                return;
            }
        }

        yield call(updatePromoTariffsActionFallback);

        onSuccess?.();
    } catch (error) {
        onError?.();
        if (error instanceof Error) {
            yield loggerSaga({ error, action: promoTariffsUpdateFailure(error.toString()) });
        }
    }
}

export function* watchPromoTariffsRoot() {
    yield takeLatest(initPromoTariffsAction.toString(), handleInitPromoTariffs);
    yield takeLatest(updatePromoTariffs.toString(), handleUpdatePromoTariffs);
}
